import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Bell, CheckCheck } from 'lucide-react';
import { api, errMsg } from '@/lib/api';
import { useI18n } from '@/lib/i18n';
import { EmptyState } from '@/components/State';
import { toast } from 'sonner';

export default function Notifications() {
  const nav = useNavigate();
  const { t, lang, tNotif } = useI18n();
  const [items, setItems] = useState([]);

  const load = async () => {
    try { const res = await api.get('/notifications'); setItems(res.data || []); }
    catch (e) { toast.error(errMsg(e)); }
  };
  useEffect(() => { load(); }, []);

  const open = async (n) => {
    if (!n.read) { try { await api.post(`/notifications/${n.id}/read`); } catch {} }
    if (n.link) nav(n.link);
    else load();
  };
  const readAll = async () => { try { await api.post('/notifications/read-all'); load(); } catch (e) { toast.error(errMsg(e)); } };

  return (
    <div className="min-h-screen bg-asgym-bg">
      <div className="mx-auto w-full max-w-[480px] px-6 py-10">
        <div className="mb-6 flex items-center justify-between">
          <button onClick={() => nav(-1)} className="flex items-center gap-1.5 text-sm font-bold text-asgym-accent"><ArrowLeft size={16} /> {t('common.back').toUpperCase()}</button>
          {items.some((n) => !n.read) && (
            <button onClick={readAll} className="flex items-center gap-1.5 text-[11px] font-bold text-asgym-sub" data-testid="mark-all-read"><CheckCheck size={14} /> {t('notif.markAllRead')}</button>
          )}
        </div>
        <h1 className="mb-6 font-display text-3xl font-extrabold tracking-tight text-white">{t('notif.title')}</h1>

        {items.length === 0 ? (
          <EmptyState icon={Bell} sub={t('notif.empty')} />
        ) : (
          <div className="space-y-2.5">
            {items.map((n) => {
              const nt = tNotif(n);
              return (
              <button key={n.id} onClick={() => open(n)} data-testid="notif-item"
                className={`flex w-full items-start gap-3 rounded-2xl border p-4 text-left transition-colors ${n.read ? 'border-white/[0.06] bg-asgym-surface' : 'border-asgym-accent/30 bg-asgym-accent/[0.07]'}`}>
                {!n.read && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-asgym-accent" />}
                <div className={n.read ? 'pl-0' : ''}>
                  <p className="text-[14px] font-bold text-white">{nt.title}</p>
                  {nt.body && <p className="mt-0.5 text-[12px] leading-snug text-asgym-sub">{nt.body}</p>}
                  <p className="mt-1 text-[10px] font-semibold text-asgym-muted">{n.created_at ? new Date(n.created_at).toLocaleString(lang === 'de' ? 'de-DE' : 'en-US', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : ''}</p>
                </div>
              </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
